import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { StringUtilsService } from '../../../../../../core/services/string-utils.service';
import { AppState } from '../../../../../../core/reducers';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RelationshipCategoryService } from '../../../../../../core/lists/_services/relationship-category.service';
import { ContactRelationshipsService } from '../../../../../../core/lists';
import { GeneralAutocompleteComponent } from '../../../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { AuthService } from '../../../../../../core/auth';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { QrveyService } from '../../../../../../core/lists/_services/qrvey.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-external-access-edit',
  templateUrl: './external-access-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExternalAccessEditComponent implements OnInit, OnDestroy, AfterViewInit {
  companyId: number;
  loadingSubject = new BehaviorSubject<boolean>(true);
  loading$: Observable<boolean>;
  externalAccessForm: FormGroup;
  hasFormErrors = false;
  submissionErrorObj: any;
  hasSubmissionErrors: boolean;
  subscriptions = [];
  entityType;
  relationCategoryList = [];
  relationEntityList = [];
  entitySearchFields = [];
  appId = null;
  rule: string;
  allPages = [];
  optionPages = [];
  selectedPages = [];
  optionEntities = [];
  selectedEntities = [];
  hasErrorConflict = false;
  @ViewChild('pagesAutocomplete') pagesAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('pagess', { static: true }) pagess: ElementRef;
  @ViewChild('entities', { static: true }) entities: ElementRef;
  constructor(
    public dialogRef: MatDialogRef<ExternalAccessEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private contactService: ContactRelationshipsService,
    private store: Store<AppState>,
    private router: Router,
    private externalAccessFormFB: FormBuilder,
    private relationshipCategoryService: RelationshipCategoryService,
    private translate: TranslateService,
    private contactRelationshipsService: ContactRelationshipsService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    public dialog: MatDialog,
    private layoutUtilsService: LayoutUtilsService,
    public stringUtils: StringUtilsService,
    private activatedRoute: ActivatedRoute,
    private qrveyService: QrveyService,
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.app_id) {
        this.appId = params.app_id;
      }
    });
  }

  ngOnInit() {
    const searchSubscription = fromEvent(this.pagess.nativeElement, 'keyup')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.pagesAutoComplete(this.pagess.nativeElement.value);
        }),
      )
      .subscribe();
    const search2Subscription = fromEvent(this.entities.nativeElement, 'keyup')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.entitiesAutoComplete(this.entities.nativeElement.value);
        }),
      )
      .subscribe();
    this.subscriptions.push(search2Subscription);
    this.subscriptions.push(searchSubscription);
    this.qrveyService.getPageGroups(this.appId).subscribe((res) => {
      this.allPages = res.data;
      this.optionPages = this.allPages;
      this.cdr.detectChanges();
    });
    this.loadCategory();
    this.createForm();
    this.entitySearchFields = this.stringUtils.getEntitySearchFields(this.entityType);
    this.externalAccessForm.get('relationCategory').valueChanges.subscribe((category) => {
      this.loadEntities(category?.id);
    });
  }

  loadEntities(id) {
    if (this.entityType && this.externalAccessForm.get('relationCategory').value) {
      this.contactRelationshipsService.getEntities(id).subscribe((res) => {
        if (!res) return;
        this.optionEntities = res.data;
        this.relationEntityList = this.optionEntities;
        this.cdr.detectChanges();
      });
    }
  }
  getTitle() {
    if (this.data.mode === 'CREATE') return 'New External Access';
    return 'Update External Access';
  }

  ngOnDestroy() {
    this.cdr.detach();
    this.subscriptions.forEach((el) => {
      if (el.sub) {
        el.sub.unsubscribe();
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.data.mode === 'UPDATE') {
      this.externalAccessForm.get('relationCategory').disable();
      this.externalAccessForm.get('type').disable();
      this.rule = this.data._item.qrvey_user_role ? this.data._item.qrvey_user_role : null;
      this.cdr.detectChanges();
    }
  }

  createForm() {
    let category = {};
    this.entityType =
      this.data._item && this.data._item.entity_type ? this.data._item.entity_type : null;

    if (this.data._item) {
      category = {
        entity_type: this.entityType,
        id: this.data._item?.team_id,
        name: this.data._item?.team_name,
      };
      this.relationCategoryList.push(category);
    }
    this.selectedEntities =
      this.data._item && this.data._item.entities ? this.data._item.entities : [];
    this.selectedPages = this.data._item && this.data._item.groups ? this.data._item.groups : [];
    this.externalAccessForm = this.externalAccessFormFB.group({
      entity: [this.data._item && this.data._item.entities ? this.data._item.entities : null],
      type: [this.entityType, Validators.required],
      relationCategory: [
        this.data._item && this.data._item.team_id ? category : null,
        Validators.required,
      ],
      pages: [
        this.data._item && this.data._item.groups ? this.data._item.groups : null,
        Validators.required,
      ],
    });
  }

  onSubmit() {
    this.hasFormErrors = false;
    const controls = this.externalAccessForm.controls;
    if (this.externalAccessForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    }
    if (!this.rule) {
      return;
    }
    this.addPageGroupInternal(this.preparePageGroupInternal());
  }

  preparePageGroupInternal() {
    const controls = this.externalAccessForm.controls;
    return {
      team_id:
        this.data._item && this.data._item.team_id
          ? this.data._item.team_id
          : controls.relationCategory?.value?.id,
      id: this.data._item && this.data._item.id ? this.data._item.id : null,
      role: this.rule,
      entity_type: controls.type.value,
      user_type: 'CONTACT',
      name: controls.relationCategory.value?.name,
      page_groups: controls.pages.value,
      entities: controls.entity?.value,
    };
  }

  addPageGroupInternal(_item) {
    this.qrveyService.putCategoryAccess(_item, this.appId).subscribe(
      () => {
        this.layoutUtilsService.showActionNotification(
          'Access Added Successfully',
          MessageType.Update,
          3000,
          false,
          false,
        );
        this.dialogRef.close();
      },
      () => {
        this.hasErrorConflict = true;
        this.cdr.detectChanges();
      },
    );
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.externalAccessForm.controls[controlName];
    if (!control) {
      return false;
    }
    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  close() {
    this.dialogRef.close();
  }

  selectType(entity_type) {
    this.selectedEntities = [];
    this.externalAccessForm.get('entity').setValue([]);
    this.externalAccessForm.get('relationCategory').setValue('');
    this.optionEntities = [];
    this.entityType = entity_type;
    this.loadCategory();
  }

  loadCategory() {
    if (!this.entityType) return;
    this.contactRelationshipsService.getRelationTypesCategory(this.entityType).subscribe((res) => {
      if (!res) return;
      this.relationCategoryList = res.data;
    });
  }

  pageFn(event: any): string {
    return event ? event.name : '';
  }

  private pagesAutoComplete(term: string) {
    let _term = '' + term;
    _term = _term.trim();
    this.optionPages = this.allPages.filter((item) => item.name.includes(_term));
    this.cdr.detectChanges();
    return;
  }

  private entitiesAutoComplete(term: string) {
    let _term = '' + term;
    _term = _term.trim();
    this.optionEntities = this.relationEntityList.filter((item) => item.name?.includes(_term));
    this.cdr.detectChanges();
    return;
  }

  remove(p): void {
    const objWithIdIndex = this.selectedPages.findIndex((obj) => obj.id === p.id);
    this.selectedPages.splice(objWithIdIndex, 1);

    this.externalAccessForm.get('pages').setValue(this.selectedPages);
    this.cdr.detectChanges();
  }

  removeEntity(p): void {
    const objWithIdIndex = this.selectedEntities.findIndex((obj) => obj.id === p.id);
    this.selectedEntities.splice(objWithIdIndex, 1);
    this.externalAccessForm.get('entity').setValue(this.selectedEntities);
    this.cdr.detectChanges();
  }

  selected1(event: MatAutocompleteSelectedEvent): void {
    this.selectedPages.push(event.option.value);
    this.pagess.nativeElement.value = '';
    this.externalAccessForm.get('pages').setValue(this.selectedPages);
    this.cdr.detectChanges();
  }

  selectEntities(event: MatAutocompleteSelectedEvent): void {
    this.selectedEntities.push(event.option.value);
    this.entities.nativeElement.value = '';
    this.externalAccessForm.get('entity').setValue(this.selectedEntities);
    this.cdr.detectChanges();
  }
  isSelected(p: any) {
    return this.selectedPages?.indexOf(p) !== -1;
  }

  isSelectedEntity(p: any) {
    return this.selectedEntities?.indexOf(p) !== -1;
  }
}
